import React from 'react';
import {connect} from 'react-redux'

import {get as _get} from "lodash";
import * as actions from '../../../store/actions'


import Input from "../../theme/forms/Input";
import api from "../../../store/api";
import ConfirmModal from "../../theme/modals/ConfirmModal";
import AdminWrapper from "../../theme/wrappers/AdminWrapper";
import PublicTopNav from "../../theme/nav/PublicTopNav";
import BaseHomePageLogoWrapper from "../../theme/logoCards/baseHomePageLogoWrapper"

import {isUserLoggedIn} from "../../../utils/session/logout";
import {addErrorAlert, toggleGlobalLoader} from "../../../store/calls/alertLoadingDispatch";
import BaseModal from "../../theme/modals/BaseModal";
import MapFrame from "../../theme/maps/mapFrame";
import PacefiFullScreenSpinner from "../../theme/loaders/pacefiFullScreenSpinner";
// const themePath = path.resolve(__dirname, `../src/themes/${process.env.THEME_NAME}.js`);
import subdomainConfigs from '../../../subdomainStyles.json';
import LogoFooter from '../../theme/logoFooter/logo';
import {projectStartSearch} from "../../../utils/projectStartSearch"
import {getSubdomain} from "../../../utils/general";
import { pullSubdomainStyleFromCookie } from '../../../utils/subdomains/configHandlers';
import AlertFeed from "../../theme/alerts/alertFeed";

class DynamicHomePage extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            property_address_value: null,
            error: null,
            displayMap: false,
            showOnlyProgramsWithFunders: true
        }

        // working default
        this.defaultGeojson = {
            "type": "FeatureCollection",
            "features": [
                {
                    "type": "feature",
                    "geometry": {
                        "type": "MultiPolygon",
                        "coordinates": []
                    }
                }
            ]
        }

        this.mapGeojson = this.defaultGeojson;
        this.subdomain = getSubdomain();

    }


    componentDidMount() {
        toggleGlobalLoader(false);
    }


    handleAddressFormSubmit = synEvent => {
        synEvent.preventDefault();
        projectStartSearch(this.state.property_address_value, this.props.history)
    }


    loadAndOpenMap = () => {
        toggleGlobalLoader(true);

        api.get('/country-geojson/', {wfunders: this.state.showOnlyProgramsWithFunders ? 1 : null})
            .then(res => {
                this.mapGeojson = res.data;
                this.setState({displayMap: false}, () => this.setState({displayMap: true})); // off before on as security and to ensure update
            })
            .catch(err => addErrorAlert("Something's not right. We had a problem getting the map data."))
            .finally(() => toggleGlobalLoader(false))
    };

    closeAndClearMap = () => {
        this.setState({displayMap: false})
    }


    render() {
        const subdomainConfig = {...subdomainConfigs.default, ...pullSubdomainStyleFromCookie(),}

        return (
            <div id="homepage-wrapper">
                <section className="hero is-fullheight" id="homepage_bg">
                    <PublicTopNav
                        // isLight
                        navbarClass=""
                    />

                    <div className="hero-body">
                        <div className="container is-flex is-justify-content-center has-text-centered"
                             style={{maxWidth: '800px'}}
                        >
                            <div className="p-6 has-background-white-bis-transparent">
                                    <h2 className="subtitle has-text-primary mb-3 is-size-1 is-size-4-mobile">
                                            {subdomainConfig['homepage-title']}
                                        </h2>
                                        <h1 className="subtitle has-text-primary mb-6 is-size-5-mobile">
                                            {subdomainConfig['homepage-subtitle']}
                                        </h1>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center'
                                }}>
                                    <div>
                                        <form onSubmit={this.handleAddressFormSubmit}
                                              className="is-flex is-flex-wrap-wrap">
                                            <div className="mr-2">
                                                <Input
                                                    type="text"
                                                    placeholder="Enter property address"
                                                    value={this.state.property_address_value}
                                                    inputClasses="is-large input"
                                                    onChange={val => this.setState({
                                                        property_address_value: val,
                                                        property_address_error: false
                                                    })}
                                                />
                                            </div>
                                            <div className="">
                                                <button type='submit' className="button is-link is-large">
                                                    Start Your Project
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                    <div className="input-error has-text-danger"
                                         style={{opacity: this.state.error ? 1 : 0}}>
                                        {this.state.error || ''}
                                    </div>
                                </div>
                                <span className="mt-3">
                                    <LogoFooter/>
                                </span>
                                <BaseHomePageLogoWrapper/>
                            </div>
                        </div>
                    </div>

                </section>

                <div id="admin-wrapper-alert-feed">
                    <AlertFeed/>
                </div>
                <PacefiFullScreenSpinner/>
            </div>

        )
    }

}


const mapStateToProps = state => ({
    subdomainInfo: state.session.subdomainInfo,
})

const mapDispatchToProps = dispatch => ({
    updateProjectInputs: data => dispatch(actions.formFlow.updateFormFlowInputs(data)),
    updateProjectComputed: data => dispatch(actions.formFlow.updateFormFlowComputed(data)),
    clearFormFlow: data => dispatch(actions.formFlow.clearFormFlow()),
    setFocusedProject: data => dispatch(actions.projectLeads.setFocusedProject()),
    updateInfoFeedDisplay: data => dispatch(actions.infoFeed.updateInfoFeedDisplay(data)),
    clearInfoFeedDisplay: data => dispatch(actions.infoFeed.clearInfoFeedDisplay()),
})


export default connect(mapStateToProps, mapDispatchToProps)(DynamicHomePage)



